<template>
  <div id="pagos-header">
    <div id="sig-container" class="full form-horizontal">
      <div class="widget">
        <div class="widget-content widget-content-mini themed-background-info text-light-op">
          <span class="float-right text-muted">
            <i class="fa fa-check"></i>
          </span>Importar información de contacto
        </div>
        <div class="widget-content border-bottom themed-background-muted text-center">
          <span
            class="muted-color"
          >Por medio de este modulo se podra cargar las gestiones realizadas.</span>
          <hr />
          <div class="row">
            <div class="loader" v-if="loading">
              <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
            </div>
            <div class="col-md-3"></div>
            <div align="center" class="col-md-6">
              <div class="row centrar">
                <label class="btn btn-primary" :class="{ disabled: loading }">
                  <i class="fa fa-file-excel-o"></i>
                  <input
                    v-on:change="cargarGestion()"
                    id="archivo"
                    ref="archivo"
                    name="archivo"
                    type="file"
                    :disabled="loading"
                    accept=".csv"
                    style="display: none;"
                  />
                  Seleccionar archivo
                </label>
                &nbsp;
                <a :href="'../files/formato-cargue-gestion.csv'" download>
                  <label class="btn btn-success">
                    <i class="fa fa-file-excel-o"></i>
                    Descargar archivo
                  </label>
                </a>
              </div>
              <div class="row centrar">
                <p>Si tienes el formato listo para el cargue de gestiones, podrás montarlo por medio del boton "Seleccionar archivo". En caso, contrario podras descargar el formato base para montar este cargue por medio de "Descargar archivo".</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-md-2 offset-md-10" style="padding-right: 50px;">
          <button
            class="btn btn-primary btn-block"
            :disabled="loading"
            v-tooltip.top="'Actualizar'"
            @click="listarArchivos()"
          >
            <i class="fa fa-sync-alt"></i> Actualizar
          </button>
        </div>
      </div>

      <br />

      <div class="table-responsive">
        <table class="table table-striped table-bordered table-vcenter">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!archivos || archivos.length == 0">
              <td colspan="3" class="text-center">No se encontraron datos</td>
            </tr>
            <tr v-for="(archivo, index) in archivos" :key="index">
              <td>{{ archivo.nombre }}</td>
              <td>{{ archivo.estado }}</td>
              <td>
                <button
                  class="btn btn-sm btn-primary"
                  :disabled="loading"
                  v-tooltip.top="'Descargar archivo'"
                  @click="descargarArchivo(archivo)"
                >
                  <i class="fa fa-download"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm btn-log"
                  :disabled="loading || archivo.estado != 'FINALIZADO'"
                  v-tooltip.top="'Descargar log'"
                  @click="descargarLog(archivo)"
                >
                  <i class="fa fa-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapGetters({
      loading: "cargueGestion/loading",
      archivos: "cargueGestion/archivos"
    })
  },
  methods: {
    listarArchivos() {
      this.$store.commit("cargueGestion/setLoading", true);
      this.$store
        .dispatch("cargueGestion/listarArchivos")
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            content: "No se pudo cargar el historial de cargues de gestiones.",
            type: "danger"
          });
        })
        .finally(() => {
          this.$store.commit("cargueGestion/setLoading", false);
        });
    },
    descargarArchivo(archivo) {
      this.$store
        .dispatch("cargueGestion/descargarArchivo", { ruta: archivo.ruta })
        .then(response => {
          FileSaver.saveAs(new Blob([response.data]), archivo.nombre);
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            content: "No se pudo descargar el archivo.",
            type: "danger"
          });
        });
    },
    descargarLog(archivo) {
      this.$store
        .dispatch("cargueGestion/descargarLog", { ruta: archivo.ruta })
        .then(response => {
          FileSaver.saveAs(new Blob([response.data]), "LOG_" + archivo.nombre);
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            content: "No se pudo descargar el log.",
            type: "danger"
          });
        });
    },
    cargarGestion() {
      this.file = this.$refs.archivo.files[0];
      if (!this.file) {
        return;
      }

      if (!/\.csv$/i.test(this.file.name)) {
        this.$notify({
          title: "Archivo no válido",
          content: "Solo se permiten archivos CSV.",
          type: "warning"
        });
        this.$refs.archivo.value = null;
        return;
      }

      let formData = new FormData();
      formData.append("datos", this.file);

      this.$store.commit("cargueGestion/setLoading", true);
      this.$store
        .dispatch("cargueGestion/cargarGestion", formData)
        .then(response => {
          this.$store.commit("cargueGestion/setLoading", false);
          // El cargue ahora es asincrono: el backend solo confirma que el
          // archivo quedo en cola (gestion_archivos, tipo
          // "cargue-masivo-gestiones"), ya no devuelve el detalle fila por
          // fila al instante, asi que no hay nada que exportar a Excel aca.
          this.$notify({
            title: "Archivo cargado",
            content:
              (response.data && response.data.mensaje) ||
              "El archivo se cargó correctamente y será procesado en breve.",
            type: "success"
          });
          this.$refs.archivo.value = null;
          this.listarArchivos();
        })
        .catch(error => {
          this.$store.commit("cargueGestion/setLoading", false);
          const mensajeError =
            (error.response &&
              error.response.data &&
              (error.response.data.error || error.response.data.message)) ||
            "Se produjo un error al tratar de importar el archivo, por favor inténtelo más tarde.";
          this.$notify({
            title: "Fallo al importar",
            content: mensajeError,
            type: "danger"
          });
          this.$refs.archivo.value = null;
        });
    }
  },
  mounted() {
    this.listarArchivos();
  }
};
</script>
<style>
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.muted-color {
  color: #b9b9b9;
  font-style: italic;
}

.centrar {
  display: block;
}

.btn-log {
  background-color: #afde5c;
  border-color: #afde5c;
  color: #fff;
}
.btn-log:hover:not(:disabled) {
  background-color: #9ecb4c;
  border-color: #9ecb4c;
  color: #fff;
}
.btn-log:disabled {
  background-color: #afde5c;
  border-color: #afde5c;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
